const remove = {
    svg: '<svg style="width:1.00rem; height:1.00rem;" viewBox="0 0 16 16"><polygon points="13 7.25 13 8.75 3 8.75 3 7.25"/></svg>',
};

export { remove as default };
